import {
  ActionGroup,
  FeatureGuide,
  PermissionToggle,
  Loader,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  getParsedCrudData,
  ALL_SHARD_MODULES
} from '@nile/components';
import { AccountClient, GET_FIELD } from '@nile/graphql/src';
import {
  Heading,
  Page,
  TextContainer,
  TextStyle
} from '@superops/ui-design-system';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { SuperSortable } from '@nile/components/src/SuperSortable/SuperSortable';
import { isEmpty, sortBy } from 'lodash';

const ResourceCodeList = styled.div`
  margin-bottom: 12px;
`;

const ResourceCodeHeading = styled.div`
  margin-bottom: 4px;
`;

function ResolutionCode(props) {
  const { isEditAuthorised, disableSort } = props;
  const [options, setOptions] = useState([]);
  const [mandatoryOnClosure, setMandatoryOnClosure] = useState(false);

  const {
    data: resolutionData,
    loading,
    error,
    refetch: refetchResolution
  } = useQuery(GET_FIELD, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      input: {
        entity: ALL_SHARD_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.RESOLUTION_CODE
      }
    },
    onCompleted({ getField }) {
      const fldOptions = getField?.options || getField?.fieldOptions;
      const sortedOptions = fldOptions ? sortBy(fldOptions, 'order') : [];
      setMandatoryOnClosure(getField?.mandatoryOnClosure);
      setOptions(sortedOptions);
    }
  });

  if (error) return <div>error occured </div>;

  const onSave = () => {
    const columnName = DEFAULT_FIELDS_BY_COLUMN_NAME.RESOLUTION_CODE;
    const baseData =
      resolutionData?.getField?.options ||
      resolutionData?.getField?.fieldOptions;

    const updatedData = options;
    const result = getParsedCrudData(baseData, updatedData);
    let updatedOptions = {};
    const { updatedItems } = result;
    if (updatedItems.length > 0) {
      updatedOptions = { ...updatedOptions, updated: updatedItems };
    }
    const variables = {
      id: resolutionData?.getField?.id,
      mandatoryOnClosure: mandatoryOnClosure,
      fieldOptionsInput: isEmpty(updatedOptions)
        ? undefined
        : JSON.stringify(updatedOptions)
    };
    props.primaryAction(variables);
  };

  return (
    <div className="full-height full-width">
      <Page
        variant="primary"
        fullWidth
        contentHeight="120px"
        subtitle={
          <>
            <TextContainer>
              <TextStyle variation="subdued">
                <FormattedMessage id="admin.resolutionCode.header.label" />
              </TextStyle>
            </TextContainer>
            <div className="mt10">
              <FeatureGuide featureName="resolutioncodes" article />
            </div>
          </>
        }
        title={
          <TextStyle variation="stronger">
            <FormattedMessage id="admin.resolutionCode.header" />
          </TextStyle>
        }
        primaryAction={
          <ActionGroup
            primaryText={<FormattedMessage id="common.save" />}
            primaryLoading={props.saveLoading}
            primaryAction={onSave}
            secondaryAction={props.secondaryAction}
            primaryDisabled={!isEditAuthorised}
          />
        }
      >
        <>
          {loading ? (
            <>
              <Loader />
            </>
          ) : (
            <>
              <SuperSortable
                className="sort-wrapper"
                list={options || []}
                onDragEnd={(reorderedData) => {
                  const updatedDataWithOrder = reorderedData.map(
                    (field, i) => ({
                      ...field,
                      order: i + 1
                    })
                  );
                  setOptions(updatedDataWithOrder);
                }}
                animation={200}
              >
                {options.map((el) => (
                  <div className="flex g5">
                    {isEditAuthorised && !disableSort && (
                      <SuperSortable.DragHandle className="mt-5" />
                    )}

                    <ResourceCodeList>
                      <ResourceCodeHeading>
                        <Heading element="h3" weight="SemiBold">
                          {el?.value}
                        </Heading>
                      </ResourceCodeHeading>
                      <div className="font-weight-500">
                        <TextStyle variation="subdued">
                          {el?.details?.description}
                        </TextStyle>
                      </div>
                    </ResourceCodeList>
                  </div>
                ))}
              </SuperSortable>

              <div className="mt40">
                <PermissionToggle
                  hideShowToClients
                  mandatoryOnClosure={mandatoryOnClosure}
                  setMandatoryOnClosure={setMandatoryOnClosure}
                  disableEdit={!isEditAuthorised}
                  hideMandatoryOnCreation
                  showWarning={props.showWarning}
                />
              </div>
            </>
          )}
        </>
      </Page>
    </div>
  );
}

export default ResolutionCode;
